import { usePDFPrintHook } from "@careinfo/layout";
import { useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import {
  patchApiData,
  patchApiFormData,
  postApiData,
} from "../../helpers/AxiosInstance";
import { toast } from "react-toastify";
import { tw } from "@careinfo/tailwind";
import Spinner from "../../components/Reusable/Spinner";
import loadable from "@loadable/component";

const EditPurchaseReturnComponent = loadable(
  () => import("../../components/PurchaseReturn/EditPurchaseReturn")
);
("");
const EditPurchaseReturn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [isRevertLoading, setRevertLoading] = useState(false);
  const queryClient = useQueryClient();
  const { id } = useParams();

  const { data, isLoading: isDataLoading } = useGetHook({
    queryKey: ["purchase-return", `purchase-return-${id}`],
    url: `${APIS.SALES_PURCHASE_RETURN}${id}/`,
    params: {},
  });

  const { data: companyData, isLoading: isCompanyDataLoading } = useGetHook({
    url: APIS.COMPANY_PROFILE,
    queryKey: ["company-profile"],
    params: {},
  });

  const handleEdit = async (values: any, isDraft: any, setError: any) => {
    setIsLoading(true);
    const url = `${APIS.SALES_PURCHASE_RETURN}${id}/`;
    const formData = new FormData();
    formData.append("voucher_date", values?.voucher_date ?? null);
    formData.append("reference_number", values?.reference_number ?? "");
    values?.reference_date
      ? formData.append("reference_date", values?.reference_date)
      : null;
    formData.append("number_series", values?.number_series);
    formData.append("entry_number", values?.entry_number);
    formData.append("party", values?.party);
    values?.bill_number
      ? formData.append("bill_number", values?.bill_number)
      : null;
    formData.append("tax_rate", values?.tax_rate);
    formData.append("taxable_amount", values?.taxable_amount);
    formData.append("total_amount", values?.total_amount);
    formData.append("discount", values?.total_discount);
    formData.append("tax_amount", values?.vat_tax_amount);

    isDraft
      ? formData.append("status", "Draft")
      : formData.append("status", "Success");
    if (values?.items) {
      const cleanedItems = values.items.map(
        ({
          is_taxable,
          last_purchase_price,
          is_maintain_stock,
          unit,
          serial_number,
          previous_quantity,
          ...rest
        }) => ({
          ...rest,
          is_taxable: is_taxable ? "true" : "false",
        })
      );
      formData.append("items", JSON.stringify(cleanedItems));
    }
    if (values?.attachment?.[0] && typeof values?.attachment !== "string") {
      formData.append("attachment", values?.attachment?.[0]);
    }
    values?.narration ? formData.append("narration", values?.narration) : null;
    try {
      const res = await patchApiFormData({ url, formData, setError });
      if (res?.status === 200) {
        queryClient.invalidateQueries({
          queryKey: ["purchase-return"],
          refetchType: "active",
        });
        if (!isDraft) {
          setSelectedOrder(res?.data?.id);
          setOpenPrintPopup(true);
        } else {
          navigate("/accounting/purchase-return");
        }
        toast.success("Updated Successfully");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrint = async () => {
    const url = APIS.BILL_PRINT;
    let formData = {
      ids: [selectedOrder],
      type: "Purchase Return",
    };

    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCancel = async () => {
    const url = `${APIS.SALES_PURCHASE_RETURN}${id}/`;
    const formData = {
       status: "Cancelled",
    };
    try {
      patchApiData({ url, formData, setError: () => {} });
    } catch (err) {
      console.error(err);
    }
  };

  const handleRevert = async (setError) => {
    const url = `${APIS.BILL}${id}/revert/`;
    setRevertLoading(true);
    try {
      const res = await postApiData({ url, formData: {}, setError });
      if (res?.status === 200) {
        queryClient.invalidateQueries({
          queryKey: ["purchase-return"],
          refetchType: "active",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setRevertLoading(false);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-4 uppercase font-extrabold items-center`}
      >
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Purchase Return
        </span>
      </div>
      {isDataLoading || isCompanyDataLoading ? (
        <Spinner />
      ) : (
        <EditPurchaseReturnComponent
          handleEdit={handleEdit}
          isLoading={isLoading}
          data={data}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          handlePrint={handlePrint}
          companyData={companyData}
          isRevertLoading={isRevertLoading}
          handleRevert={handleRevert}
          handleCancel={handleCancel}
          isPrintLoading={isPrintLoading}
        />
      )}
    </>
  );
};
export default EditPurchaseReturn;
